<template>
  <div >
    <h5>Run detail: {{runId}}</h5>
    <table class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Win%</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluation in evaluations" v-bind:key="evaluation.name">
          <td id="nameCell" >{{evaluation.name}} </td>
          <td>{{evaluation.averagePercentage}}</td>
        </tr>
      </tbody>
    </table>
    <button type="button" class="btn btn-outline-light" @click="back()">Hide</button>
  </div>
</template>

<script>
export default {
  name: 'RunDetail',
  props: {
    evaluations: Array,
    runId: String
  },
  data () {
    return {
      title: 'RunDetail'
    }
  },
  methods: {
    back () {
      this.$emit ('backFromDetail', false)
    }
  },
  mounted () {

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}
</style>
